import { type ApiClient, listQueryParams } from "./client";
import type { ListQuery, OpportunityDetail, OpportunityFilters, OpportunityImage, OpportunityRow, Page, TimelineEvent } from "./types";

/** Opportunities: domain operations the UI depends on. Implementations: HTTP (below) and mock (src/api/mock). */
export interface OpportunitiesApi {
  list(query: ListQuery<OpportunityFilters>): Promise<Page<OpportunityRow>>;
  get(id: string): Promise<OpportunityDetail>;
  timeline(id: string): Promise<TimelineEvent[]>;
  images(id: string): Promise<OpportunityImage[]>;
  /** A one-time link to work the lead in the dealer app as yourself (opens a new tab). */
  actLink(input: { organizationId: string; storeId?: string; opportunityId?: string }): Promise<{ url: string; expiresAt: string }>;
}

export function createHttpOpportunitiesApi(client: ApiClient): OpportunitiesApi {
  return {
    list: (q) => client.call("listOpportunities", { query: listQueryParams(q) }),
    get: (id) => client.call("getOpportunity", { params: { id } }),
    timeline: async (id) => (await client.call<{ items: TimelineEvent[] }>("getOpportunityTimeline", { params: { id } })).items,
    images: async (id) => (await client.call<{ items: OpportunityImage[] }>("listOpportunityImages", { params: { id } })).items,
    actLink: (input) => client.call("createActLink", { body: input }),
  };
}
